import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import EMBED_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/embed-activeicon.svg';
import EMBED_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/embed-deactiveicon.svg';
import UserProfile from './UserProfile';
import OpenAIConfiguration from './OpenAIConfiguration';
import ChangePassword from './ChangePassword';
import { ImProfile } from 'react-icons/im';
import { RiLockPasswordLine } from 'react-icons/ri';
import { SiOpenai } from 'react-icons/si';
import { deleteWithToken, getLocalStorage } from '../API/Api';
import { useNavigate } from 'react-router-dom';
import { ProgressContext } from '../contexts/ProgressContext';
import SubContext from '../contexts/SubContext';
import { getPlanLevel } from '../API/Constant';
import { toast } from 'react-toastify';
import { Loader } from 'lucide-react';
import { RxExclamationTriangle } from 'react-icons/rx';
import CustomPopUp from '../components/CustomPopUp';

const DangerCard = ({ title, description, onClick, color }) => (
  <div className='col-12 col-md-6'>
    <div className='p-3 mt-3 rounded bg-light' style={{ border: `2px solid ${color}` }}>
      <h6 className='outfit-semibold' style={{ color: color }}>
        {title}
      </h6>
      <p className='outfit-regular mb-3'>{description}</p>
      <button className='chatbot-save-btn outfit-medium d-flex align-items-center gap-2' style={{ background: color }} onClick={onClick}>
        {title}
      </button>
    </div>
  </div>
);

const Settings = () => {
  const user = JSON.parse(getLocalStorage('userDetails'));
  const [activeTab, setActiveTab] = useState('openAI');

  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [apiTokenData, setApiTokenData] = useState('');
  const [deleteAllPopUpOpen, setDeleteAllPopUpOpen] = useState(false);
  const [deleteAccountPopUpOpen, setDeleteAccountPopUpOpen] = useState(false);
  const { stopPolling } = useContext(ProgressContext);
  const subsFlag = useContext(SubContext);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
    } else {
      navigate('/login');
    }
  }, [navigate]);

  const handleDeleteAction = async (type) => {
    setLoader(true);
    const endpoint = type === 'data' ? 'Content_DeleteAPI/' : 'account_delete';

    try {
      const response = await deleteWithToken(endpoint, apiTokenData);

      if (response.status === 200) {
        toast.success(type === 'data' ? response.message : 'Your account and all associated data have been permanently deleted.');
        subsFlag.setUpdateValue('1');
        type === 'data' ? setDeleteAllPopUpOpen(false) : setDeleteAccountPopUpOpen(false);
        if (type === 'account') {
          localStorage.clear();
          navigate('/login');
        }
        stopPolling();
        window.location.reload();
      } else {
        toast.error(response.message || 'Something went wrong.');
      }
    } catch (error) {
      toast.error('Something went wrong. Please try again later.');
    } finally {
      setLoader(false);
    }
  };
  return (
    <div className='container'>
      <div className='row m-0 mt-4 ps-md-4 ps-sm-4 ps-4 pe-md-4 pe-sm-4 pe-4 mb-4'>
        <div class='soft-tab-wrapper d-flex p-1 w-100'>
          {/* <button className={`soft-tab-btn gap-2 outfit-medium ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => setActiveTab('profile')}>
            <ImProfile />
            Profile
          </button> */}
          <button className={`soft-tab-btn gap-2 outfit-medium ${activeTab === 'openAI' ? 'active' : ''}`} onClick={() => setActiveTab('openAI')}>
            <SiOpenai />
            Advanced Modal Configuration
          </button>
          {user?.user_type === '1' && (
            <button className={`soft-tab-btn gap-2 outfit-medium ${activeTab === 'password' ? 'active' : ''}`} onClick={() => setActiveTab('password')}>
              <RiLockPasswordLine />
              Change Password
            </button>
          )}
        </div>
        <div className='comniq-container mt-3'>
          <>
            {/* {activeTab === 'profile' && <UserProfile />} */}
            {activeTab === 'openAI' && <OpenAIConfiguration />}
            {activeTab === 'password' && user?.user_type === '1' && <ChangePassword />}
          </>
        </div>

        <div className='setting-card-section mt-4'>
          <div className='setting-card-text'>
            <h5 className='outfit-semibold mb-0 text-danger'>
              <RxExclamationTriangle className='me-2' />
              Danger Zone
            </h5>
            <p className='outfit-regular'>These actions are irreversible. Proceed with caution.</p>
          </div>
          <div className='row g-4 align-items-start'>
            <DangerCard
              title='Clear All Data'
              description='This will permanently remove all your stored data including history, settings, and preferences.'
              onClick={() => setDeleteAllPopUpOpen(true)}
              color='#e8590c'
            />
            <DangerCard
              title='Delete Account'
              description='This will permanently delete your account and all associated information. You won’t be able to recover it.'
              onClick={() => setDeleteAccountPopUpOpen(true)}
              color='#dc3545'
            />
          </div>
        </div>

        {loader && (
          <div className='loader-center'>
            <Loader />
          </div>
        )}
        {deleteAllPopUpOpen && (
          <CustomPopUp
            title="You're about to delete your data?"
            onConfirm={() => handleDeleteAction('data')}
            onClose={() => setDeleteAllPopUpOpen(false)}
            confirmText='Delete'
            closeText='Cancel'
            variant='error1'
            initialWidth='500px'
            loader={loader}
          >
            <p className='outfit-regular'>Your Company Profile, FAQ’s and Bot Messages will be permanently deleted. You won't be able to see them again.</p>
          </CustomPopUp>
        )}

        {deleteAccountPopUpOpen && (
          <CustomPopUp
            title="You're about to delete your account?"
            onConfirm={() => handleDeleteAction('account')}
            onClose={() => setDeleteAccountPopUpOpen(false)}
            confirmText='Delete'
            closeText='Cancel'
            variant='error'
            initialWidth='500px'
            loader={loader}
          >
            <p className='outfit-regular'>
              This action will permanently delete your entire account, including your company profile, FAQs, and bot messages. This data cannot be recovered once deleted. Are you
              sure you want to proceed?
            </p>
          </CustomPopUp>
        )}
      </div>
    </div>
  );
};

export default Settings;
